module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAcElEQVQ4y2NgGBTgi4b5fxgmBJDV0tiA9+///6+vh2AQm2QD+vv/A1VAMIhNtAHr1///b2AAwTADYHygHGED5s9HaETHQDnCBoD8i2w7siuAcsSFAcgQZKeD2NCAJC0a9++HYLLTwfnzEEzzhDS0AQDuV8IE0FjmqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CA.png
// module id = 1103
// module chunks = 0